// extracted by mini-css-extract-plugin
export default {"buttonStyle":"CustomButton_buttonStyle__slECp","buttonActiveStyle":"CustomButton_buttonActiveStyle__-Awu5"};